import { OppButton } from './ui/control';
import { Component, type ReactNode, type ErrorInfo } from 'react';
import { SemanticState } from './semantic/SemanticState';

interface Props { children: ReactNode; }
interface State { hasError: boolean; error: Error | null; }

export class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    const details = {
      name: error?.name,
      message: error?.message,
      stack: error?.stack,
      cause: error && typeof error === 'object' ? (error as Error & { cause?: unknown }).cause : undefined,
      error: error && typeof error === 'object' ? { ...error } : error,
      componentStack: info.componentStack,
    };
    console.error('[OPP ErrorBoundary]', JSON.stringify(details));
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen min-h-[var(--litopia-layout-100dvh)] items-center justify-center p-8 bg-[hsl(var(--opp-surface-raised))]">
          <SemanticState
            kind="error"
            illustration="state-error-network"
            title="页面出现错误"
            description={this.state.error?.message || '请刷新页面后重试。'}
            action={<OppButton onClick={() => window.location.reload()} variant="primary" className="rounded-full px-6 py-2 text-sm font-medium">刷新页面</OppButton>}
          />
        </div>
      );
    }
    return this.props.children;
  }
}
